import React from 'react';

// Inject the keyframe once, lazily, so the spinner works without touching global CSS.
let injected = false;
function ensureKeyframes() {
  if (injected || typeof document === 'undefined') return;
  injected = true;
  const s = document.createElement('style');
  s.textContent = '@keyframes rd-spin{to{transform:rotate(360deg)}}';
  document.head.appendChild(s);
}

// Uses currentColor, so it takes the surrounding text color unless `color` is set.
export default function Spinner({ size = 20, stroke = 3, color, style }) {
  ensureKeyframes();
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 50 50"
      role="status"
      aria-label="Loading"
      style={{ animation: 'rd-spin 0.7s linear infinite', display: 'inline-block', color, ...style }}
    >
      <circle cx="25" cy="25" r="20" fill="none" stroke="currentColor" strokeWidth={stroke} strokeOpacity="0.25" />
      <path d="M25 5 a20 20 0 0 1 20 20" fill="none" stroke="currentColor" strokeWidth={stroke} strokeLinecap="round" />
    </svg>
  );
}

// Centered spinner for a whole page / large area (e.g. auth check, route loading).
export function FullPageSpinner({ color = '#FF5722', minHeight = '70vh' }) {
  return (
    <div style={{ minHeight, display: 'grid', placeItems: 'center' }}>
      <Spinner size={40} color={color} />
    </div>
  );
}
